module.exports = __webpack_public_path__ + "img/61.8a24aa2c.jpg";